import { useState } from "react";
// import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";

import DriverTableRow from "./DriverTableRow";
import { Paper } from "@mui/material";

const DriverData = () => {
  const { drivers, isLoading } = useSelector((state) => state.drivers);
  const dispatch = useDispatch();

  const [driverData, setDriverData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  return (


    <TableContainer sx={{ whiteSpace: {xs:"nowrap",}}}>
      <Table aria-label="customized table">
        <TableHead
        >
          <TableRow>
            <TableCell>Id</TableCell>
            <TableCell>First Name</TableCell>
            <TableCell>Last Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Mobile Number</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <TextField
                fullWidth
                helperText='Search by id'
                id='id-searchbox'
                label='Id'
                name='searchId'
                // onChange={handleSearch}
                />
            </TableCell>
            <TableCell>
              <TextField
                fullWidth
                helperText='Search by name'
                id='name-searchbox'
                label='User'
                name='searchuser'
                // onChange={handleSearch}
                />
            </TableCell>

            <TableCell>
              <TextField
                fullWidth
                helperText='Search by email'
                id='email-searchbox'
                label='Status'
                name='searchstatus'
                // onChange={handleSearch}
                />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={7}>
                <Typography variant='p' align='center'>
                  Loading...
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            <DriverTableRow row={drivers}></DriverTableRow>
            )}
        </TableBody>
      </Table>
    </TableContainer>

  );
};

export default DriverData;
